export default function getItemClass(baseClass, isHovered, isSelected) {
  if (!!baseClass && isSelected) {
    return `${baseClass}--selected`;
  } else if (!!baseClass && isHovered) {
    return `${baseClass}--hovered`;
  } else {
    return "";
  }
}
